const UserIdType = Symbol();

export class UserId {
    [UserIdType]: any;
    readonly value: string;

    private constructor(id: string) {
        this.value = id;
    }

    equals(other: UserId): boolean {
        return this.value === other.value;
    }

    static fromString(id: string): UserId {
        return new UserId(id);
    }

    static fromNothing(): UserId {
        return new UserId("");
    }
}
